import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insurance-details-dialog',
  templateUrl: './insurance-details-dialog.component.html',
  styleUrls: ['./insurance-details-dialog.component.scss']
})
export class InsuranceDetailsDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
